import { useCallback, useEffect, useRef } from 'react';

// Custom react hook
const useOutsideClick = <T extends Element>(onClick: () => void) => {
  const ref = useRef<T>(null);

  const handleClick = useCallback(
    e => {
      const inside = ref.current?.contains(e.target);

      if (inside) {
        return;
      }

      onClick();
    },
    [onClick, ref],
  );

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, [handleClick]);

  return ref;
};

export default useOutsideClick;
